import {
  NBS_API_GET_CHATS_SUCCESS,
  NBS_API_BLOCK_USER_SUCCESS,
  NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS,
  RESET_GET_CHATS_OPENED,
  RESET_GET_CHATS_SEEN,
  NBS_WS_GET_MESSAGE_SUCCESS,
  DELETE_CHAT,
} from '../../constants/actions';

import { deepCopy } from '../../assets/helpers/utils';
import { getCurrentUserChatroom } from '../actions/socket';

const initialState = [];

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case NBS_API_GET_CHATS_SUCCESS:
      const currentState = action.silent ? [] : [...state];
      const { chats } = action.response;
      const currentUserId = getCurrentUserChatroom();
      if (chats.length > 0) {
        for (let user of chats) {
          if (user.received_total > 0) {
            // hack - if in chat-room with this user do not update red-dot
            if (currentUserId === user.user_id) {
              user.unseen = false;
            }
            currentState.push(user);
          }
        }
        currentState.sort((a, b) =>
          a.received_last > b.received_last ? -1 : 1
        );

        let hasSticky = false;

        for (let user of chats) {
          if (user.isSticked) {
            hasSticky = true;
            break;
          }
        }

        if (hasSticky) {
          currentState.sort((a, b) =>
            a.isSticked === b.isSticked ? 0 : a.isSticked ? -1 : 1
          );
        }
      }

      return currentState;
    case NBS_API_DELETE_USER_CHAT_AND_UNMATCH_SUCCESS:
    case NBS_API_BLOCK_USER_SUCCESS:
      const currentUsers = [...state];
      const newUsers = currentUsers.filter(
        (user) => user.user_id !== action.userId
      );
      return newUsers;
    case RESET_GET_CHATS_OPENED:
      const newData = [];
      state.forEach((user) => {
        if (user.user_id === action.userId) {
          user.unopened = false;
        }
        newData.push(user);
      });
      return newData;
    case RESET_GET_CHATS_SEEN:
      const newListData = [];
      state.forEach((user) => {
        if (user.user_id === action.userId) {
          user.unseen = false;
        }
        newListData.push(user);
      });
      return newListData;
    case NBS_WS_GET_MESSAGE_SUCCESS:
      const newChatsData = deepCopy(state);
      newChatsData.forEach((user) => {
        if (user.user_id === action.data.user_id) {
          user.online = true;
          if (action.data.updateRedDot === true) {
            user.unseen = true;
          }
        }
      });
      return newChatsData;
    case DELETE_CHAT:
      const stateCopy = state.filter((s) => s.user_id !== action.data.user_id);
      return stateCopy;

    default:
      return state;
  }
}
